import { render, staticRenderFns } from "./FabricView.vue?vue&type=template&id=0d6fb787&scoped=true"
import script from "./FabricView.vue?vue&type=script&lang=js"
export * from "./FabricView.vue?vue&type=script&lang=js"
import style0 from "./FabricView.vue?vue&type=style&index=0&id=0d6fb787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fb787",
  null
  
)

export default component.exports